module.exports = __webpack_public_path__ + "img/icon-org-contact.8b8c65b2.svg";